import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StoresService } from 'src/app/home/services/stores.service';
import { UserService } from 'src/app/home/services/user.service';

@Component({
  selector: 'app-add-user',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss', '../../app.component.scss', '../../shared/base-modal.style.scss']
})
export class AddUserComponent implements OnInit{
  public dialogData: any;

  public roles = [];
  public selectedRole = "";

  public stores = [];
  public selectedStores = [];
  public diplaySelectedStores = [];
  public isSelectAllStores = false;

  public isWebPermissions = "";
  public isHardwarePermissions = "";

  public contactNumberCode = "+353";

  public userDetails = {
    firstName: "",
    lastName: "",
    userName: "",
    roleId: "",
    email: "",
    contactNumber: "",
    password: "",
    passwordConfirmation: "",
    emailNotificationEnabled: ""
  };

  public serverErrorMsg = "";

  constructor(
    public dialogRef: MatDialogRef<AddUserComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    private storeService: StoresService
  ){
    if(data){
      this.dialogData = data;
    }
  }

  ngOnInit(): void {
    this.getRoles();
  }

  getRoles(){
    this.userService.getRoles(['id', 'name']).subscribe((res)=>{
      this.roles = res.data;
    })
  }

  openRolesDropdown(event){
    let popupDiv = document.getElementById("roles-dropdown");

      if (!popupDiv.className.includes("active")) {
        popupDiv.classList.add("active");
        event.stopPropagation();

        document.addEventListener('click', function(event: any) {
          if (
            popupDiv.className.includes("active")
          ) {
            popupDiv.classList.remove("active");
          }
        })
      }
  }

  openStoresDropdown(event){
    let popupDiv = document.getElementById("stores-dropdown");

      if (!popupDiv.className.includes("active")) {
        popupDiv.classList.add("active");
        event.stopPropagation();

        this.closePopupOutside("stores-dropdown");
      }
  }

  onRoleChange(role: any){
    this.userDetails.roleId = `${role.id}`;
    this.selectedRole = role.name;

    this.userService.getRoleDetails(role.id, 0).subscribe({
      next: (res) => {
        if (res.data) {
          this.isWebPermissions = res.data.is_web_permission;
          this.isHardwarePermissions = res.data.is_hardware_permission;

          if (this.isHardwarePermissions) {
            let loggedUser = JSON.parse(localStorage.getItem('role'));
            this.storeService.getStores(loggedUser.resource_id, ['id', 'name']).subscribe({
              next: (res) => {
                if (res.data.length !== 0) {
                  this.stores = res.data;
                }
              }
            })
          }
        }
      }
    });
  }

  onSelectAllStores(event){
    if (event.target.checked) {
      this.selectedStores = this.stores;
    }else{
      this.selectedStores = [];
    }
  }

  onSelectStores(event, store){
    if (event.target.checked) {
      this.selectedStores.push(store);  
    }else{
      this.selectedStores = this.selectedStores.filter((element)=>{
        return element.id !== store.id;
      });
    }

    this.isSelectAllStores = this.stores.length === this.selectedStores.length;

  }

  onRemoveSelectStore(storeId: number){
    this.selectedStores = this.selectedStores.filter((element)=>{
      return element.id !== storeId;
    });

    this.isSelectAllStores = this.stores.length === this.selectedStores.length;
  }

  isStoreSelected(storeId: number){
    return this.selectedStores.some((el) => el.id === storeId)
  }

  addUser(formData){
    if (formData.password === formData.password_confirmation) {
      if (this.isHardwarePermissions && this.selectedStores.length === 0) {
        return
      }

      if (this.isHardwarePermissions) {
        formData.stores = [];
        
        this.selectedStores.forEach((selectedStore) => {
          formData.stores.push(selectedStore.id)
        });
      }

      if (this.isWebPermissions) {
        let loggedUser = JSON.parse(localStorage.getItem('role'));
        formData.resource_id = [loggedUser.resource_id];
      }

      if (formData.contact_number !== "") {
        formData.contact_number = this.contactNumberCode + " " + formData.contact_number
      }

      this.userService.addUsers(formData).subscribe({
        next: (res) => {
          if (res.data) {
            this.dialogRef.close(true);
          }
        },
        error: (errorResponse) => {
          if (errorResponse.error) {
            this.serverErrorMsg = errorResponse.error.message;
          }
          
        },
      });
    }
    
  }

  onClose(): void {
    this.dialogRef.close();
  }

  closePopupOutside(popupId: string){
    let popupDiv = document.getElementById(popupId);

    document.addEventListener('click', function(event: any) {
      if (
        popupDiv.className.includes("active") &&
        !popupDiv.contains(event.target)
      ) {
        popupDiv.classList.remove("active");
      }
    })
  }
}
